import React, { useState } from 'react';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Checkbox,
  Text,
  Alert,
  Box,
} from '@razorpay/blade/components';
import { dateFormats, getFormattedDateValue } from 'utils/Dates';

interface MonthChangeConfirmationModalProps {
  isOpen: boolean;
  onDismiss: () => void;
  onConfirm: () => void;
  selectedMonth: string;
}

export const MonthChangeConfirmationModal: React.FC<MonthChangeConfirmationModalProps> = ({
  isOpen,
  onDismiss,
  onConfirm,
  selectedMonth,
}) => {
  const [isConfirmed, setIsConfirmed] = useState(false);

  const payrollMonthFormatted = getFormattedDateValue({
    date: selectedMonth,
    formatString: dateFormats.monthYear,
    filler: '',
  });

  const handleConfirm = () => {
    if (isConfirmed) {
      onConfirm();
      setIsConfirmed(false);
    }
  };

  const handleDismiss = () => {
    setIsConfirmed(false);
    onDismiss();
  };

  return (
    <Modal isOpen={isOpen} onDismiss={handleDismiss} size="small">
      <ModalHeader
        title="Update Salary Register"
        subtitle={`for ${payrollMonthFormatted} Payroll`}
      />
      <ModalBody>
        <Box display="flex" flexDirection="column" gap="spacing.5">
          <Alert
            color="information"
            emphasis="subtle"
            isDismissible={false}
            description={
              <Text size="medium" color="surface.text.gray.subtle">
                Please ensure that you upload past executed salary register. Do not upload any
                pending payroll month's salary register through this flow
              </Text>
            }
          />
          <Box>
            <Checkbox
              isChecked={isConfirmed}
              onChange={({ isChecked }) => setIsConfirmed(isChecked)}>
              {`I am uploading already executed salary register of ${payrollMonthFormatted}`}
            </Checkbox>
          </Box>
        </Box>
      </ModalBody>
      <ModalFooter>
        <Box display="flex" gap="spacing.3" justifyContent="flex-end" width="100%">
          <Button variant="secondary" onClick={handleDismiss}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleConfirm} isDisabled={!isConfirmed}>
            Proceed
          </Button>
        </Box>
      </ModalFooter>
    </Modal>
  );
};
